import styled, { css } from 'styled-components';

interface ThumbsContainerProps {
  feedbackSent: boolean;
}

export const ChatThreadContainer = styled.div`
  flex: 1;
  width: calc(100% + 30px);
  overflow-y: scroll;
  padding: 16px 0;
  border-radius: 5px;
  padding-left: 30px;
  margin-left: -30px;
`;

export const ChatThreadBgBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ChatThreadPlaceHolderBox = styled.div`
  flex: 1;
  width: 100%;
  overflow-y: scroll;
  padding: 16px 0;
`;

export const ChatThreadPlaceHolderIconContainer = styled.div`
  svg {
    width: 55px;
    height: 55px;
    display: block;
    margin: 80px auto 0;
  }
`;

export const ChatThreadPlaceHolderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: auto;
`;

export const ChatThreadPlaceHolderColumn = styled.div`
  width: 23%;

  img {
    display: block;
    margin: auto;
  }
`;

export const ChatThreadPlaceHolderColumnTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #4c4c4c;
  text-align: center;
  margin-bottom: 25px;
`;

export const ChatThreadPlaceHolderTitle = styled.div`
  font-size: 38px;
  text-align: center;
  color: #1a1a1a;
  font-weight: lighter;
  padding-top: 60px;
`;

export const ChatThreadPlaceHolderSubTitle = styled.div`
  font-size: 20px;
  text-align: center;
  color: #000;
  font-weight: lighter;
`;

export const LoadingText = styled.span`
  font-size: 12px;
  color: #000;
  display: inline-block;
  padding-left: 8px;
  position: relative;
  top: 1px;
`;

export const LoadingContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const ChatThreadPlaceHolderQuestionItem = styled.div`
  font-size: 16px;
  color: #4c4c4c;
  padding: 4px 16px;
  margin-bottom: 15px;
  border-radius: 6px;
  border: 1px solid rgb(0 0 0 / 15%);
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: #fff;
  cursor: pointer;

  &:hover {
    background-color: #eee;
  }
`;

export const ChatFeed = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const UserChatContainer = styled.div`
  width: 725px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 15px;
  border-radius: 12px;
  background-color: #808283;
`;

export const UserChatMessage = styled.h3`
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`;

export const BotChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: #000;
  border-radius: 5px 5px 5px 0;
  margin: 32px 0 0;
`;

export const BotMsgMeta = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 2px;

  h4 {
    margin: 0 0 8px;
  }
`;

export const BotMsgSection = styled.div`
  display: flex;
`;

export const BotChatMessage = styled.p`
  width: 725px;
  word-wrap: break-word;
  border-radius: 12px;
  padding: 15px;
  background: #fff;
  margin: 0;
  font-size: 16px;
`;

export const BotMsgOptions = styled.div`
  display: flex;
  margin: 12px;

  svg {
    font-size: 14px;
    cursor: pointer;
  }

  svg:hover {
    transform: scale(1.1);
    transition: all 0.1s ease-in-out;
  }
`;

export const BotMsgError = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  h4 {
    margin-top: 10px;
  }
`;

export const BotChatFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 725px;
  margin-top: 8px;
`;

export const BotChatTime = styled.span`
  font-size: 12px;
  color: #808284;
`;

export const NextQuestionContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  left: -23px;
`;

export const CONTAINER_WIDTH = 725;

export const NextQuestionContentContainer = styled.div`
  display: inline-block;
  width: ${CONTAINER_WIDTH}px;
  overflow: auto;
  white-space: nowrap;
  padding: 10px 0 14px;
`;

export const NextQuestionContentAll = styled.div`
  display: inline-block;
  white-space: nowrap;
`;

export const NextQuestionItem = styled.div`
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 25%);
  margin-right: 8px;
  display: inline-block;
  border-radius: 8px;
  background: #fff;
  padding: 6px 10px;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #4d7eff;
  }

  &.asked {
    cursor: not-allowed;
    background: #dcdcdc;
    color: #a3a3a3;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const CheckboxGroupContainer = styled.div`
  margin-bottom: 16px;

  label {
    margin: 8px 0;
  }
`;

export const TextAreaBox = styled.div`
  margin-bottom: 16px;
`;

export const ThumbsContainer = styled.div<ThumbsContainerProps>`
  display: flex;
  font-size: 24px;

  svg {
    margin: 0 4px;
    cursor: pointer;
    font-size: 14px;
  }

  ${(props) =>
    props.feedbackSent
      ? css`
          svg:hover {
            cursor: not-allowed;
          }
        `
      : css`
          svg:hover {
            transform: scale(1.1);
            transition: all 0.1s ease-in-out;
          }
        `}
`;

export const ChatSep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12px 0;

  hr {
    display: block;
    height: 1px;
    width: 100%;
    border: 0;
    padding: 0;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  label {
    margin-inline-start: 0 !important;
  }
`;

export const MetricName = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #000;
`;
